export default __webpack_public_path__ + "static/pinterest-8f0c34f44019fff319e45704e40953c8.png";